import React from "react";

import BackgroundWrapper from "_components/atoms/backgroundWrapper";
import useStyles         from "_styles/atoms/cardWrapper";

const component = props => {
	const { isHomeFeed, type, noBackground } = props;

	const { classes } = useStyles ( { props } );

	if ( noBackground ) {
		return (
			<div className = { isHomeFeed ? classes.feedContainer : classes.container }
				style         = { { ...props?.customStyles } }
				type          = { type }
			>
				{ props?.children }
			</div>
		);
	}

	return (
		<BackgroundWrapper className = { isHomeFeed ? classes.feedContainer : classes.container }
			style                       = { { ...props?.customStyles } }
			type                        = { type }
		>
			{ props?.children }
		</BackgroundWrapper>
	);
};

export default component;
